<template>
    <div>
        <v-row>
            <v-col>
                <h4>RHS Workstream Template</h4>
                <v-snackbar
                    v-model="snackbar"
                    :timeout="3000"
                    :color="snackbarColor+' darken-1'"
                    text
                    absolute
                    center
                >
                    {{ snackbarText }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                            :color="snackbarColor+' darken-1'"
                            fab
                            x-small
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                        >
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn
                    color="grey lighten-3"
                    small
                    @click.stop="isOpenPayrollReportsDialog = true"
                >
                    Payroll Reports
                </v-btn>
                <PayrollReports v-model="isOpenPayrollReportsDialog"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" sm="4">
                <v-checkbox
                    class="my-0"
                    v-model="SplitOvernight"
                    label="Split Overnight"
                    @click="getPayrollSplit()"
                    :disabled="isDisabledCheckboxAndRadioBtn() || radioGroup == 1 || radioGroup == 2 || isViewGeneratedPayroll"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="8" sm="9">
                <v-radio-group class="my-0" v-model="radioGroup" mandatory row>
                    <v-radio
                        label="Don't Group"
                        value=0
                        @click="groupPayroll()"
                        :disabled="isDisabledCheckboxAndRadioBtn() || isViewGeneratedPayroll"
                    ></v-radio>
                    <v-radio
                        label="Group By Employee"
                        value=1
                        @click="groupPayroll()"
                        :disabled="isDisabledCheckboxAndRadioBtn() || SplitOvernight || isViewGeneratedPayroll"
                    ></v-radio>
                    <v-radio
                        label="Group by Programs"
                        value=2
                        @click="groupByProgram()"
                        :disabled="isDisabledCheckboxAndRadioBtn() || SplitOvernight || isViewGeneratedPayroll"
                    >
                    </v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text class="">
                        <v-data-table
                            :headers="headers"
                            :items="timesheets"
                            :loading="isLoadingConfirmedPayroll"
                            loading-text="Loading... Please wait"
                            class="elevation-0"
                            :show-expand="radioGroup == 2"
                            :expanded.sync="expanded"
                        >
                            <template v-slot:top>
                                <v-toolbar
                                    class="elevation-1"
                                    flat
                                >
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="elevation-1"
                                                color="primary darken-2"
                                                small 
                                                fab
                                                @click.stop="generatedPayrollDialog = true"
                                            >
                                                <v-icon>mdi-content-save-settings</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Generated Payrolls</span>
                                    </v-tooltip>
                                    <v-dialog
                                        v-model="generatedPayrollDialog"
                                        transition="dialog-top-transition"
                                        max-width="840"
                                    >
                                        <v-card>
                                            <v-card-title class="white--text text-h6 primary darken-2">
                                                Generated Payrolls
                                            </v-card-title>

                                            <v-card-text class="mt-3">
                                                <v-data-table
                                                    class="mx-auto"
                                                    :headers="generatedPayrollsHeader"
                                                    :items="generatedPayrolls"
                                                    :loading="generatedPayrollsLoading"
                                                    loading-text="Loading... Please wait"
                                                >
                                                    <template
                                                        v-slot:body="{ items }"
                                                    >
                                                        <tbody>
                                                            <tr
                                                                v-for="item in items"
                                                                :key="item._id"
                                                            >
                                                                <td class="">{{ item.DateGenerate }}</td>
                                                                <td class="">{{ item.DateStart }}</td>
                                                                <td class="">{{ item.DateEnd }}</td>
                                                                <td class="">
                                                                    <v-icon small color="secondary" class="mr-2" @click="viewGeneratedPayrolls(item)">
                                                                        mdi-eye
                                                                    </v-icon>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-data-table>
                                            </v-card-text>

                                            <v-divider></v-divider>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    class="elevation-1"
                                                    color=""
                                                    @click="generatedPayrollDialog = false"
                                                >
                                                    close
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                    <p class="mb-0" v-if="generatePayrollFrom != '' && generatePayrollTo != ''">{{ `${generatePayrollFrom} ~ ${generatePayrollTo}`  }}</p>
                                    <!-- <p class="mb-0" v-else-if="generatePayrollFrom != undefined && generatePayrollTo != undefined">{{ `${generatePayrollFrom} ~ ${generatePayrollTo}` }}</p> -->
                                    <p class="mb-0" v-else></p>
                                    <v-spacer></v-spacer>
                                    <!-- <v-dialog
                                        v-model="generatePayrollDialog"
                                        max-width="500"
                                        persistent
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                color="primary"
                                                dark
                                                class="mb-2"
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                            >
                                                Generate
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-toolbar color="primary" class="text-h5" dark>
                                                Generate Payroll
                                            </v-toolbar>
                                            <v-card-text class="py-0 px-auto my-3">
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="6"
                                                    >
                                                        <DatePicker
                                                            v-model="generatePayrollFrom"
                                                            label="From"
                                                        ></DatePicker>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="6"
                                                    >
                                                        <DatePicker
                                                            v-model="generatePayrollTo"
                                                            label="To"
                                                        ></DatePicker>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    class="elevation-1"
                                                    color=""
                                                    text
                                                    @click="generatePayrollDialog = false"
                                                >
                                                    Close
                                                </v-btn>

                                                <v-btn
                                                    class="elevation-1"
                                                    color="primary"
                                                    text
                                                    @click="getConfirmedPayroll()"
                                                    :loading="generatePayrollIsLoading"
                                                    :disabled="generatePayrollIsLoading"
                                                >
                                                    Confirm
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog> -->
                                    <v-dialog
                                        v-model="generatePayrollDialog"
                                        max-width="840"
                                        persistent
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                color="grey lighten-4"
                                                class="my-3"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                Generate
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-toolbar color="grey lighten-4" class="text-h6 elevation-1">
                                                Generate Payroll
                                            </v-toolbar>
                                            
                                            <v-card-text class="mt-3 py-0">
                                                <v-form ref="form">
                                                    <v-row>
                                                        <v-col
                                                            cols="12"
                                                            md="6"
                                                            sm="6"
                                                        >
                                                            <v-menu
                                                                v-model="menu"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="generatePayrollFrom"
                                                                        label="Date Start"
                                                                        prepend-icon="mdi-calendar"
                                                                        readonly
                                                                        :rules="[v => !!v || 'Date Start is required']"
                                                                        required
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="generatePayrollFrom"
                                                                    @input="menu = false"
                                                                ></v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            md="6"
                                                            sm="6"
                                                        >
                                                            <v-menu
                                                                v-model="menu2"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="generatePayrollTo"
                                                                        label="Date End"
                                                                        prepend-icon="mdi-calendar"
                                                                        readonly
                                                                        :rules="[v => !!v || 'Date End is required']"
                                                                        required
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="generatePayrollTo"
                                                                    @input="menu2 = false"
                                                                ></v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col
                                                            class=""
                                                            cols="12"
                                                            md="4"
                                                            sm="4"
                                                        >
                                                            <v-select
                                                                v-model="program"
                                                                :items="units"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                label="Programs"
                                                                dense
                                                                multiple
                                                                outlined
                                                                clearable
                                                                @change="programChange"
                                                            >
                                                                <template v-slot:prepend-item>
                                                                    <v-list-item>
                                                                        <v-list-item-content>
                                                                            <v-text-field 
                                                                                v-model="searchTerm" 
                                                                                placeholder="Search" 
                                                                                @input="searchUnits"
                                                                                clearable
                                                                            >
                                                                            </v-text-field>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-divider class="mt-2"></v-divider>
                                                                    <v-list-item
                                                                        ripple
                                                                        @mousedown.prevent
                                                                        @click="toggle"
                                                                    >
                                                                        <v-list-item-action>
                                                                            <v-icon :color="program.length > 0 ? 'indigo darken-4' : ''">
                                                                                {{ icon }}
                                                                            </v-icon>
                                                                        </v-list-item-action>
                                                                        <v-list-item-content>
                                                                            <v-list-item-title>
                                                                                Select All
                                                                            </v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-divider class=""></v-divider>
                                                                    <v-list>
                                                                        <v-list-group
                                                                            prepend-icon=""
                                                                        >
                                                                            <template v-slot:activator>
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title v-text="'Select By State'"></v-list-item-title>
                                                                                </v-list-item-content>
                                                                            </template>
                                                                            <v-list-item
                                                                                ripple
                                                                                @mousedown.prevent
                                                                                @click="toggleUtahPrograms"
                                                                            >
                                                                                <v-list-item-action>
                                                                                    <v-icon :color="utahPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                                                        {{ filterUtahIcon }}
                                                                                    </v-icon>
                                                                                </v-list-item-action>
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title v-text="'Utah Programs'"></v-list-item-title>
                                                                                </v-list-item-content>
                                                                            </v-list-item>
                                                                            <v-list-item
                                                                                @mousedown.prevent
                                                                                @click="toggleNevadaPrograms"
                                                                            >
                                                                                <v-list-item-action>
                                                                                    <v-icon :color="nevadaPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                                                        {{ filterNevadaIcon}}
                                                                                    </v-icon>
                                                                                </v-list-item-action>
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title v-text="'Nevada Programs'"></v-list-item-title>
                                                                                </v-list-item-content>
                                                                            </v-list-item>
                                                                        </v-list-group>
                                                                    </v-list>
                                                                    <v-divider class="mb-2"></v-divider>
                                                                </template>
                                                                <template v-slot:selection="{ item, index }">
                                                                    <v-chip v-if="index < 2">
                                                                        <span>{{ item.Name }}</span>
                                                                    </v-chip>
                                                                    <span
                                                                        v-if="index === 2"
                                                                        class="grey--text text-caption"
                                                                    >
                                                                        (+{{ program.length - 2 }} others)
                                                                    </span>
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                        <v-col
                                                            class=""
                                                            cols="12"
                                                            md="4"
                                                            sm="4"
                                                        >
                                                            <v-select
                                                                v-model="position"
                                                                :items="droles"
                                                                label="Positions"
                                                                dense
                                                                outlined
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col
                                                            class=""
                                                            cols="12"
                                                            md="4"
                                                            sm="4"
                                                        >
                                                            <v-select
                                                                v-model="employee"
                                                                :items="employees"
                                                                label="Employees"
                                                                item-text="Name"
                                                                item-value="_id"
                                                                dense
                                                                outlined
                                                                clearable
                                                            ></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    class="elevation-1"
                                                    color=""
                                                    text
                                                    @click="generatePayrollDialog = false"
                                                >
                                                    Close
                                                </v-btn>

                                                <v-btn
                                                    class="elevation-1"
                                                    color="grey lighten-3"
                                                    @click="getConfirmedPayroll()"
                                                    :loading="generatePayrollIsLoading"
                                                    :disabled="generatePayrollIsLoading"
                                                >
                                                    Confirm
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <div>
                                    <v-icon small color="green" class="mr-2" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                </div>
                            </template>
                            <template  v-slot:item="{ item, expand, isExpanded }">
                                <tr>
                                    
                                    <td v-if="radioGroup == 2">
                                        <v-btn 
                                            @click="expand(!isExpanded)"
                                            variant="plain"
                                            icon
                                            small
                                        >
                                            <v-icon>{{isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"}}</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>
                                        {{ item.employee }}
                                    </td>
                                    <td>
                                        {{ item.position }}
                                    </td>
                                    <td v-if="radioGroup == 0">
                                        {{ item.program[0] }}
                                    </td>
                                    <td v-else>
                                        {{ item.program }}
                                    </td>
                                    <td>
                                        {{ }}
                                    </td>
                                    <td>
                                        {{ item.regular }}
                                    </td>
                                    <td>
                                        {{ item.overtime }}
                                    </td>
                                    <td v-if="radioGroup == 2">
                                        {{ }}
                                    </td>
                                    <td v-if="radioGroup == 2">
                                        {{ }}
                                    </td>
                                </tr>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }" v-if="radioGroup == 2">
                                <tr v-for="data in item.programList" :key="data.id">
                                    <td></td>
                                    <td>{{ data.employee }}</td>
                                    <td>{{ data.position }}</td>
                                    <td>{{ data.program[0] }}</td>
                                    <td>{{ data.rate }}</td>
                                    <td>{{ data.regular }}</td>
                                    <td>{{ data.overtime }}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>

                            <template v-slot:footer>
                                <v-dialog
                                    v-model="editedItemDialog"
                                    max-width="900px"
                                >
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Edit</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.employee"
                                                            label="First Name"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.lastName"
                                                            label="Last Name"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.middleName"
                                                            label="Middle Name"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.employee_id"
                                                            label="Employee ID"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.workLocation"
                                                            label="Workplace Location"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.position"
                                                            label="Job Name"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.hourly"
                                                            label="Hourly"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.regular"
                                                            label="Salaried"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.overtime"
                                                            label="Overtime"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.doubleOvertime"
                                                            label="Double Overtime"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.paidHoliday"
                                                            label="Paid Holiday"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.paidTimeOff"
                                                            label="Paid Time Off"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.sick"
                                                            label="Sick"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.piece"
                                                            label="Piece"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.restAndRecovery"
                                                            label="Rest and Recovery"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.nonProductive"
                                                            label="Non-Productive"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.tipCreditAdjustment"
                                                            label="Tip Credit Adjustment"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.pieceAdjustment"
                                                            label="Piece Adjustment"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.weightedOvertime"
                                                            label="Weighted Overtime"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.weightedDoubleOvertime"
                                                            label="Weighted Double Overtime"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="6"
                                                        md="4"
                                                    >
                                                        <v-text-field
                                                            v-model="editedItem.workstreamIdentifier"
                                                            label="Workstream Identifier"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeItem"
                                            >
                                                Close
                                            </v-btn>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="saveItem"
                                                :disabled="isLoadingSaveEditedItemBtn"
                                                :loading="isLoadingSaveEditedItemBtn"
                                            >
                                                Save
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="my-2 mx-auto">
                        <v-btn
                            :disabled="timesheets.length <= 0"
                            class="me-3"
                            color="primary"
                            small
                            @click="downloadPayroll()"
                        >
                            Download
                        </v-btn>
                        <!-- <v-menu offset-x :disabled="timesheets.length <= 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="me-3"
                                    color="primary"
                                    dark
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Download
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item link @click="downloadPayroll()">
                                    <v-list-item-title>Payroll Review</v-list-item-title>
                                </v-list-item>
                                <v-list-item link @click="downloadPaychecks()">
                                    <v-list-item-title>Paychecks Report</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu> -->
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="elevation-1"
                                    color="primary darken-2"
                                    x-small
                                    fab
                                    text
                                    v-bind="attrs"
                                    v-on="on"
                                    :loading="isSaveGeneratedPayrollsLoadingBtn"
                                    :disabled="isSaveGeneratedPayrollsLoadingBtn || isViewGeneratedPayroll"
                                    @click="saveGeneratePayrolls()"
                                >
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                            </template>
                            <span>Save generated payrolls</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import axios from 'axios';
import moment from "moment";

import {mapGetters, mapMutations, mapState} from "vuex";
import {setUserTz} from "../../../../utils/timezone";

// import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import PayrollReports from '../custompayroll/PayrollReports.vue';

const url = require("../../../client_config/config").url;

export default {
    components: {PayrollReports},

    data: () => ({
        menu: false,
        menu2: false,
        headers: [
            {text: 'Employee Name', value: 'employee'},
            {text: 'Position', value: 'position'},
            {text: 'Workplace', value: 'program'},
            {text: 'Salaried Hours', value: 'salariedHours'},
            {text: 'Regular Hours', value: 'regular'},
            {text: 'Overtime Hours', value: 'overtime'},
            {text: 'Paid time off Hours', value: 'paidTimeOff'},
            {text: 'Sick Hours', value: 'sick'},
            // {text: 'Rate', value: 'rate'},
            // {text: "Actions", value: "actions", sortable: false},
        ],
        units: [],
        unitsCopy: [],
        employees: [],
        state: localStorage.getItem('userState'),
        userRole: localStorage.getItem('userRole'),
        userCompanies: JSON.parse(localStorage.getItem("userCompanies")),
        dateStart:"",
        dateEnd: "",
        employee: "",
        position: "",
        program: [],
        utahPrograms: [],
        nevadaPrograms: [],
        timesheets: [],
        radioGroup: 0,
        SplitOvernight: false,

        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        editedItemDialog: false,

        searchTerm: "",
        selectedUnits: [],
        options: {},
        totalData: 0,
        isLoadingConfirmedPayroll: false,

        // filterPayrollDialog: false,
        generatePayrollDialog: false,
        generatedPayrollDialog: false,
        
        // filterPayrollIsLoading: false,
        generatePayrollIsLoading: false,
        isSaveGeneratedPayrollsLoadingBtn: false,
        isLoadingSaveEditedItemBtn: false,

        generatePayrollTitle: {from: '', to: ''},
        generatedPayrollsHeader: [
            {text: 'Date Generate', value: 'DateGenerate'},
            {text: 'From', value: 'DateStart'},
            {text: 'To', value: 'DateEnd'},
            {text: 'View', sortable: false},
        ],
        generatedPayrolls: [],
        generatedPayrollsLoading: false,

        snackbar: false,
        snackbarText: '',
        snackbarColor: '',

        generatePayrollFromRules: [
            v => !!v || 'Date Start is required',
        ],
        generatePayrollToRulse: [
            v => !!v || 'Date End is required',
        ],

        isViewGeneratedPayroll: false,
        selectedGeneratedPayroll_id: "",

        isOpenPayrollReportsDialog: false,
        expanded: []
    }),

    async created() {
        this.getUnits();
        this.getEmployees();
        this.getGeneratedPayrolls();
        this.resetData();
    },

    computed: {
        ...mapState({
            droles: 'userRoles',
            rhsPayroll: state => state.payroll.rhsPayroll,
        }),
        ...mapGetters({
            getUserTimezone: "timezones/getUserTimezone",
            getDefaultTz: "timezones/getDefaultTz",
        }),

        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },

        /*
        filteredEmployee(){
          return this.employees.filter(user => user.Role ===  this.position && user.Program.includes(this.program))
        },
        */

        generatePayrollFrom: {
            get() {
                return this.$store.state.payroll.dateStart;
            },
            set(val) {
                this.setDateStart(val);
            }
        },

        generatePayrollTo: {
            get() {
                return this.$store.state.payroll.dateEnd;
            },
            set(val) {
                this.setDateEnd(val);
            }
        },

        likesAllUnits() {
            return this.program.length === this.units.length
        },

        likesSomeUnits() {
            return this.program.length > 0 && !this.likesAllUnits
        },

        icon() {
            if (this.likesAllUnits) return 'mdi-close-box'
            if (this.likesSomeUnits) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        
        /*--------------------- Select All Utah programs -----------------*/
        selectedAllUtahPrograms() {
            let sum = 0
            
            this.units.forEach(item => {
                return item.State == "Utah" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterUtahIcon() {
            if (this.selectedAllUtahPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/
        /*---------------------- Select All Nevada programs ------------------*/
        selectedAllNevadaPrograms() {
            let sum = 0

            this.units.forEach(item => {
                return item.State == "Nevada" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterNevadaIcon() {
            if (this.selectedAllNevadaPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/

        
    },

    watch: {
        // options: {
        //     handler() {
        //         this.getConfirmedPayroll();
        //     },
        //     deep: true,
        // },
    },

    mounted() {
        // this.getConfirmedPayroll();
    },

    methods: {
        ...mapMutations({
            setDateStart: "payroll/SET_DATE_START",
            setDateEnd: "payroll/SET_DATE_END",
        }),

        searchUnits(e) {
            console.log(e);
            //console.log(this.units);

            if (!this.searchTerm) {
                this.units = this.unitsCopy;
            } else {
                this.units = this.unitsCopy.filter((item) => {
                    return this.searchTerm.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                });
            }
        },

        toggle() {
            this.$nextTick(() => {
                if (this.likesAllUnits) {
                    this.utahPrograms = []
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.program = this.units.slice()
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        toggleUtahPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllUtahPrograms) {
                    this.utahPrograms = []
                    this.program = []
                } else {
                    this.utahPrograms = this.units.filter(item => item.State == "Utah")
                    this.program = this.utahPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },
        toggleNevadaPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllNevadaPrograms) {
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.nevadaPrograms = this.units.filter(item => item.State == "Nevada")
                    this.program = this.nevadaPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        programChange() {
            this.units = this.unitsCopy;
        },

        getUnits: async function () {
            await axios.get(`${url}/units`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item)
                })
            });

            this.unitsCopy = [...this.units];
        },

        async getEmployees() {
            axios.get(`${url}/users/state/${this.state}`).then(res => {
                this.employees = res.data.users;
            });
        },

        getConfirmedPayroll() {
            if (this.$refs.form.validate()) {
                this.generatePayrollIsLoading = true;
                this.isLoadingConfirmedPayroll = true;

                if (this.employee == null || this.employee === "") {
                    this.employee = "All";
                }

                const {page, itemsPerPage} = this.options;

                let req_body = {
                    Program: this.program,
                    Position: this.position,
                    Employee: this.employee,
                    DateStart: this.generatePayrollFrom,
                    DateEnd: this.generatePayrollTo,
                    GroupEmployee: this.radioGroup,
                    Timezone: this.userTimezone,
                    page: page,
                    size: itemsPerPage,
                    userState: this.state,
                };

                this.timesheets = [];

                axios.post(`${url}/payroll/timesheets`, req_body).then(res => {
                    this.totalData = res.data.total;
                    let count = 1;
                    res.data.timesheets.forEach((value) => {

                        let actualClockIn = "";
                        let actualClockOut = "";
                        // let totalTimeFull = 0;

                        value.scheduleClockIn = moment(new Date(value.ScheduleIn)).format("hh:mm a");
                        value.scheduleClockOut = moment(new Date(value.ScheduleOut)).format("hh:mm a");

                        value.ScheduleIn = (value.ScheduleIn[0] == undefined ? value.ClockIn : value.ScheduleIn[0])
                        value.date = moment(new Date(value.ScheduleIn)).tz(this.userTimezone).format("YYYY-MM-DD");
                        value.position = value.EmployeePosition[0];
                        value.program = this.findProgram(value.Program[0]);
                        value.ClientName = value.ClientName[0];

                        value.employee = value.EmployeeName[0]

                        // Splits the Name
                        // let employeeName = value.EmployeeName[0].split(" ");
                        // if (employeeName[1] != undefined) {
                        //     value.employee = employeeName[0];
                        //     value.lastName = employeeName[1];

                        //     if (employeeName[2] != undefined) {
                        //         if (employeeName[2] == "") {
                        //             value.employee = employeeName[0];
                        //             value.lastName = employeeName[1];
                        //         } else if (employeeName[2] == "Jr." || employeeName[2] == "Jr") {
                        //             value.lastName += " " + employeeName[2];
                        //         } else if (employeeName[1].length == 1) {
                        //             value.middleName = employeeName[1];
                        //             value.lastName = employeeName[2];
                        //         } else {
                        //             value.employee += " " + employeeName[1];
                        //             value.lastName = employeeName[2];
                        //         }
                        //     }
                        // }

                        value.UserId = value._id.employeeID;
                        value.Rate = (value.Rate == undefined ? 0 : value.Rate);
                        value.rate = "$" + value.Rate[0];

                        value.actualClockIn = (value.ClockIn == "") ? "" : moment(new Date(value.ClockIn)).format("hh:mm a");
                        value.actualClockOut = (value.ClockOut == "") ? "" : moment(new Date(value.ClockOut)).format("hh:mm a");

                        actualClockIn = this.getRoundedDate(15, new Date(value.ClockIn));
                        if (value.ClockOut != null) {
                            actualClockOut = (value.ClockOut == "" || value.ClockOut.length == 0) ? "" : this.getRoundedDate(15, new Date(value.ClockOut));
                        }

                        value.roundedClockIn = moment(new Date(actualClockIn)).format("hh:mm a");
                        value.roundedClockOut = (actualClockOut == "") ? "" : moment(new Date(actualClockOut)).format("hh:mm a");
                        
                        let getRoundedHours = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                        let rounded = null;

                        if (getRoundedHours < 0) {
                            rounded = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).add(1, 'days').diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                            
                        } else {
                            rounded = getRoundedHours
                        }

                        value.regular = (rounded > 8) ? 8 : rounded;

                        value.overtime = (rounded > 8) ? rounded - 8 : 0;

                        // value.overtime = (value.regular > 8) ? value.regular - 8 : 0;
                        // value.overtime = value.overtime.toFixed(2);

                        // totalTimeFull = (actualClockOut == "") ? 0 : moment(new Date(actualClockOut)).diff(moment(new Date(actualClockIn)));
                        // let hours = moment.duration(totalTimeFull).hours();
                        // let minutes = moment.duration(totalTimeFull).minutes() / 60;

                        // value.total = (parseFloat(hours) + parseFloat(minutes)).toFixed(2);
                        // value.cost = "$" + (parseFloat(totalTimeFull) / 3600000) * parseFloat(value.Rate[0]);

                        value.total = rounded;

                        let parsedCost = (parseFloat(value.total)) * parseFloat(value.Rate[0]);
                        value.cost = "$" + parsedCost;

                        value.id = count++;

                        this.timesheets.push(value);
                    });
                }).finally(() => {
                    this.generatePayrollDialog = false;
                    this.generatePayrollIsLoading = false;
                    this.isLoadingConfirmedPayroll = false;
                    this.isViewGeneratedPayroll = false;
                    this.SplitOvernight = false;
                    this.radioGroup = 0;
                    this.selectedGeneratedPayroll_id = ''
                });
            }

            // USAGE //

            // Round existing date to 5 minutes
            //getRoundedDate(15, new Date()); // 2018-01-26T00:45:00.000Z

            // Get current time rounded to 30 minutes
            //getRoundedDate(30); // 2018-01-26T00:30:00.000Z
        },

        getRoundedDate(minutes, d = new Date()) {
            let ms = 1000 * 60 * minutes; // convert minutes to ms
            let roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
            return roundedDate
        },

        findProgram(programID) {
            return this.units.filter(unit => {
                if (unit._id == programID) return unit
            }).map(value => {
                return value.Name
            });
        },


        async groupPayroll() {
            this.generatePayrollIsLoading = true;
            this.isLoadingConfirmedPayroll = true;

            let timesheets = [];

            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }

            this.headers = [
                {text: 'Employee Name', value: 'employee'},
                {text: 'Position', value: 'position'},
                {text: 'Workplace', value: 'program'},
                {text: 'Salaried Hours', value: 'salariedHours'},
                {text: 'Regular Hours', value: 'regular'},
                {text: 'Overtime Hours', value: 'overtime'},
                {text: 'Paid time off Hours', value: 'paidTimeOff'},
                {text: 'Sick Hours', value: 'sick'},
            ];

            var req_body = {
                Program: this.program,
                Position: this.position,
                Employee: this.employee,
                DateStart: this.generatePayrollFrom,
                DateEnd: this.generatePayrollTo,
                GroupEmployee: this.radioGroup,
                Timezone: this.userTimezone,
            };

            if (this.radioGroup == 0) {
                this.SplitOvernight = false;
                this.getConfirmedPayroll();
            } else {

                try {
                    await axios.post(`${url}/payroll/timesheets`, req_body).then(res => {
                        this.timesheets = [];
                        res.data.timesheets.forEach((value) => {
                            let actualClockIn = "";
                            let actualClockOut = "";

                            value.ScheduleIn = (value.ScheduleIn[0] == undefined ? value.ClockIn : value.ScheduleIn[0])
                            let date = moment(new Date(value.ScheduleIn)).tz(this.userTimezone).format("YYYY-MM-DD");

                            value.employee = value.EmployeeName;
                            value.UserId = value._id.employeeID;
                            value.position = value.EmployeePosition;
                            value.program = value.ProgramName;

                            // Splits the name
                            // let employeeName = value.EmployeeName.split(" ");
                            // if (employeeName[1] != undefined) {
                            //     value.employee = employeeName[0];
                            //     value.lastName = employeeName[1];

                            //     if (employeeName[2] != undefined) {
                            //         if (employeeName[2] == "") {
                            //             value.employee = employeeName[0];
                            //             value.lastName = employeeName[1];
                            //         } else if (employeeName[2] == "Jr." || employeeName[2] == "Jr") {
                            //             value.lastName += " " + employeeName[2];
                            //         } else if (employeeName[1].length == 1) {
                            //             value.middleName = employeeName[1];
                            //             value.lastName = employeeName[2];
                            //         } else {
                            //             value.employee += " " + employeeName[1];
                            //             value.lastName = employeeName[2];
                            //         }
                            //     }
                            // }
                            
                            
                            value.Rate = (value.Rate == undefined ? 0 : value.Rate);
                            value.rate = "$" + value.Rate;

                            value.startTime = moment(new Date(this.generatePayrollFrom)).format("DD MMM YYYY");
                            value.endTime = moment(new Date(this.generatePayrollTo)).format("DD MMM YYYY");

                            actualClockIn = this.getRoundedDate(15, new Date(value.ClockIn));
                            if (value.ClockOut != null) {
                                actualClockOut = (value.ClockOut == "" || value.ClockOut.length == 0) ? "" : this.getRoundedDate(15, new Date(value.ClockOut));
                            }

                            let roundedClockIn = moment(new Date(actualClockIn)).format("hh:mm a");
                            let roundedClockOut = (actualClockOut == "") ? "" : moment(new Date(actualClockOut)).format("hh:mm a");

                            let getRoundedHours = moment.duration(moment(new Date(date + " " + roundedClockOut)).diff(moment(new Date(date + " " + roundedClockIn) ))).asHours()
                            let rounded = null;

                            if (getRoundedHours < 0) {
                                rounded = moment.duration(moment(new Date(date + " " + roundedClockOut)).add(1, 'days').diff(moment(new Date(date + " " + roundedClockIn) ))).asHours()
                                
                            } else {
                                rounded = getRoundedHours
                            }
                            
                            value.regular = (rounded > 8) ? 8 : rounded;

                            value.overtime = (rounded > 8) ? rounded - 8 : 0;

                            value.total = rounded;
                            let parsedCost = (parseFloat(value.total)) * (parseFloat(value.Rate) || 0);
                            value.cost = parsedCost.toFixed(2);

                            timesheets.push(value);
                        });
                    });

                    let totalReg = 0
                    let totalTime = 0;
                    let totalOT = 0;
                    let totalCost= 0;

                    timesheets[timesheets.length] = {
                        _id: {
                            employeeID: ""
                        }
                    }
                    
                    timesheets = timesheets.filter((item, index) => {
                        if (timesheets[index+1] != timesheets[timesheets.length]) {
                            if (item._id.employeeID == timesheets[index+1]._id.employeeID) {
                                totalReg = totalReg + parseFloat(item.regular)
                                totalTime = totalTime + parseFloat(item.total)
                                totalOT = totalOT + parseFloat(item.overtime)
                                totalCost = totalCost + parseFloat(item.cost)
                            } else {
                                totalReg = totalReg + parseFloat(item.regular)
                                totalTime = totalTime + parseFloat(item.total)
                                totalOT = totalOT + parseFloat(item.overtime)
                                totalCost = totalCost + parseFloat(item.cost)

                                item.regular = totalReg.toFixed(2)
                                item.total = totalTime
                                item.overtime = totalOT.toFixed(2)
                                item.cost = "$" + totalCost.toFixed(2)
                                
                                totalReg = 0
                                totalTime = 0
                                totalOT = 0
                                totalCost= 0

                                return item
                            }
                        }
                    })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.timesheets = timesheets;

                    this.generatePayrollDialog = false;
                    this.generatePayrollIsLoading = false;
                    this.isLoadingConfirmedPayroll = false;
                    this.isViewGeneratedPayroll = false;
                    this.selectedGeneratedPayroll_id = '';
                }
            }
        },

        async groupByProgram () {
            this.generatePayrollIsLoading = true;
            this.isLoadingConfirmedPayroll = true;

            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }

            this.headers = [
                {text: 'Employee Name', value: ''},
                {text: 'Position', value: ''},
                {text: 'Workplace', value: 'program'},
                {text: 'Salaried Hours', value: ''},
                {text: 'Regular Hours', value: 'regular'},
                {text: 'Overtime Hours', value: 'overtime'},
                {text: 'Paid time off Hours', value: ''},
                {text: 'Sick Hours', value: ''},
            ];

            var req_body = {
                Program: this.program,
                Position: this.position,
                Employee: this.employee,
                DateStart: this.generatePayrollFrom,
                DateEnd: this.generatePayrollTo,
                GroupEmployee: this.radioGroup,
                Timezone: this.userTimezone,
            };

            if (this.radioGroup == 0) {
                this.SplitOvernight = false;
                this.getConfirmedPayroll();
            } else {
                await axios.post(`${url}/payroll/timesheets`, req_body).then(res => {
                    this.timesheets = [];
                    
                    let timesheets = [];
                    let count = 1;

                    res.data.timesheets.forEach((value) => {
                        let actualClockIn = "";
                        let actualClockOut = "";

                        value.scheduleClockIn = moment(new Date(value.ScheduleIn)).format("hh:mm a");
                        value.scheduleClockOut = moment(new Date(value.ScheduleOut)).format("hh:mm a");
                        
                        value.ScheduleIn = (value.ScheduleIn[0] == undefined ? value.ClockIn : value.ScheduleIn[0])
                        value.date = moment(new Date(value.ScheduleIn)).tz(this.userTimezone).format("YYYY-MM-DD");
                        value.position = value.EmployeePosition[0];
                        value.program = this.findProgram(value.Program[0]);
                        value.ClientName = value.ClientName[0];

                        value.employee = value.EmployeeName[0]

                        value.UserId = value._id.employeeID;
                        value.Rate = (value.Rate == undefined ? 0 : value.Rate);
                        value.rate = "$" + value.Rate[0];

                        value.actualClockIn = (value.ClockIn == "") ? "" : moment(new Date(value.ClockIn)).format("hh:mm a");
                        value.actualClockOut = (value.ClockOut == "") ? "" : moment(new Date(value.ClockOut)).format("hh:mm a");

                        actualClockIn = this.getRoundedDate(15, new Date(value.ClockIn));
                        if (value.ClockOut != null) {
                            actualClockOut = (value.ClockOut == "" || value.ClockOut.length == 0) ? "" : this.getRoundedDate(15, new Date(value.ClockOut));
                        }

                        value.roundedClockIn = moment(new Date(actualClockIn)).format("hh:mm a");
                        value.roundedClockOut = (actualClockOut == "") ? "" : moment(new Date(actualClockOut)).format("hh:mm a");
                        
                        let getRoundedHours = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                        let rounded = null;

                        if (getRoundedHours < 0) {
                            rounded = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).add(1, 'days').diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                            
                        } else {
                            rounded = getRoundedHours
                        }

                        value.regular = (rounded > 8) ? 8 : rounded;

                        value.overtime = (rounded > 8) ? rounded - 8 : 0;

                        value.total = rounded;

                        let parsedCost = (parseFloat(value.total)) * parseFloat(value.Rate[0]);
                        value.cost = "$" + parsedCost;

                        value.id = count++;

                        timesheets.push(value);
                    });

                    // Sort by Program (Ascending order)
                    timesheets.sort((a, b) => {
                        if (a.program[0] < b.program[0]) {
                            return -1;
                        }
                        if (a.program[0] > b.program[0]) {
                            return 1;
                        }
                    
                        // names must be equal
                        return 0;
                    })

                    // Sort by Employee (Ascending order)
                    timesheets.sort((a, b) => {
                        if (a.employee < b.employee) {
                            return -1;
                        }
                        if (a.employee > b.employee) {
                            return 1;
                        }
                    
                        // names must be equal
                        return 0;
                    })

                    

                    // Insert total hours of every programs
                    let programTotalReg = 0, programTotalOT = 0;
                    let programList = [];

                    timesheets[timesheets.length] = {program: [""]};

                    timesheets.forEach((item, index) => {
                        if (timesheets[index+1] != timesheets[timesheets.length]) {
                            if (item.program[0] == timesheets[index+1].program[0]) {
                                programTotalReg = programTotalReg + parseFloat(item.regular);
                                programTotalOT = programTotalOT + parseFloat(item.overtime);

                                programList.push(item)
                            } else {
                                programTotalReg = programTotalReg + parseFloat(item.regular);
                                programTotalOT = programTotalOT + parseFloat(item.overtime);

                                // overallReg = overallReg + parseFloat(programTotalReg)
                                // overallOT = overallOT + parseFloat(programTotalOT)

                                programList.push(item)

                                this.timesheets.push({
                                    id: item.id,
                                    employee: item.employee,
                                    program: item.program[0] + " Total",
                                    regular: programTotalReg,
                                    overtime: programTotalOT,
                                    programList: programList
                                })

                                programTotalReg = 0;
                                programTotalOT = 0;
                                programList = [];
                            }
                        } 
                    })
                }).finally(() => {
                    this.generatePayrollDialog = false;
                    this.generatePayrollIsLoading = false;
                    this.isLoadingConfirmedPayroll = false;
                    this.isViewGeneratedPayroll = false;
                    this.SplitOvernight = false;
                    this.selectedGeneratedPayroll_id = ''
                });
            }
        },

        // groupByProgramList (item) {
        //     let str = ""
        //     // item.programList != undefined ? console.log(item.programList) : console.log(undefined);
        //     if (item.programList != undefined) {
        //         item.programList.forEach(data => {
        //         str += `<td></td>`
        //         str += `<td>${data.employee}</td>`
        //         str += `<td>${data.position}</td>`
        //         // str += `<td>${data.program[0]}</td>`
        //         str += `<td>${data.rate}</td>`
        //         str += `<td>${data.regular}</td>`
        //         str += `<td>${data.overtime}</td>`
        //         str += `<td></td>`
        //         str += `<td></td>`
        //     }) 
        //     }
            
        //     return str;
        // },

        async getPayrollSplit() {
            if (this.SplitOvernight) {
                this.headers = [
                    {text: 'Employee Name', value: 'employee'},
                    {text: 'Position', value: 'position'},
                    {text: 'Workplace', value: 'program'},
                    {text: 'Salaried Hours', value: 'salariedHours'},
                    {text: 'Regular Hours', value: 'regular'},
                    {text: 'Overtime Hours', value: 'overtime'},
                    {text: 'Paid time off Hours', value: 'paidTimeOff'},
                    {text: 'Sick Hours', value: 'sick'},
                ]

                let timesheetSplit = [];

                this.timesheets.forEach(async (value) => {
                    let clockoutDate = moment(new Date(value.ScheduleOut[0])).format("YYYY-MM-DD");
                    let clockinDate = moment(new Date(value.ScheduleIn[0])).format("YYYY-MM-DD");

                    if (clockoutDate != clockinDate) {
                        let clockInSchedFull = moment(moment(new Date(value.ScheduleIn[0])).format('YYYY-MM-DD HH:mm'));
                        let clockOutSchedFull = moment(moment(new Date(value.ScheduleOut[0])).format('YYYY-MM-DD hh:mm'));
                        let midnightDateSched = moment(moment(new Date(value.ScheduleOut[0])).format('YYYY-MM-DD 00:00'));

                        let splitInRegular = midnightDateSched.diff(clockInSchedFull);
                        let splitOutRegular = clockOutSchedFull.diff(midnightDateSched);
                        let regularIN = moment.duration(splitInRegular).hours() + ":" + Math.floor(moment.duration(splitInRegular).minutes());

                        let clockInFull = moment(moment(new Date(value.ClockIn)).format('YYYY-MM-DD HH:mm'));
                        let clockOutFull = moment(moment(new Date(value.ClockOut)).format('YYYY-MM-DD hh:mm'));
                        let midnightDate = moment(moment(new Date(value.ClockOut)).format('YYYY-MM-DD 00:00'));

                        let splitInTotal = midnightDate.diff(clockInFull);
                        let splitOutTotal = clockOutFull.diff(midnightDate);
                        let regularOUT = moment.duration(splitOutRegular).hours() + ":" + Math.floor(moment.duration(splitOutRegular).minutes());

                        let totalIN = (value.ClockOut == 0) ? 0 : moment.duration(splitInTotal).hours() + ":" + Math.floor(moment.duration(splitInTotal).minutes());
                        let costIN = (parseFloat(value.Rate[0]) * (parseFloat(splitInRegular) / 3600000)).toFixed(2);

                        let totalOUT = moment.duration(splitOutTotal).hours() + ":" + Math.floor(moment.duration(splitOutTotal).minutes());
                        let costOUT = (parseFloat(value.Rate[0]) * (parseFloat(splitOutRegular) / 3600000)).toFixed(2);

                        let row = {
                            position: value.position,
                            employee: value.employee,
                            lastName: value.lastName,
                            middleName: value.middleName,
                            ClientName: value.ClientName,
                            program: value.program,
                            PaychexID: value.PaychexID,
                            UserId: value.UserId,
                            rate: value.rate,
                            startTime: value.scheduleClockIn,
                            endTime: "mid night",
                            scheduleClockIn: value.scheduleClockIn,
                            scheduleClockOut: "mid night",
                            actualClockIn: value.actualClockIn,
                            actualClockOut: value.actualClockOut,
                            roundedClockIn: value.roundedClockIn,
                            roundedClockOut: value.roundedClockOut,
                            regular: regularIN,
                            total: totalIN,
                            cost: `$${costIN}`,
                            date: clockinDate,
                        };
                        timesheetSplit.push(row);

                        row = {
                            position: value.position,
                            employee: value.employee,
                            lastName: value.lastName,
                            middleName: value.middleName,
                            ClientName: value.ClientName,
                            program: value.program,
                            PaychexID: value.PaychexID,
                            UserId: value.UserId,
                            rate: value.rate,
                            startTime: "mid night",
                            endTime: value.scheduleClockOut,
                            scheduleClockIn: "mid night",
                            scheduleClockOut: value.scheduleClockOut,
                            actualClockIn: value.actualClockIn,
                            actualClockOut: value.actualClockOut,
                            roundedClockIn: value.roundedClockIn,
                            roundedClockOut: value.roundedClockOut,
                            regular: regularOUT,
                            total: totalOUT,
                            cost: `$${costOUT}`,
                            date: clockoutDate
                        };
                        timesheetSplit.push(row);
                    } else {
                        timesheetSplit.push(value);
                    }
                });
                this.timesheets = [];
                this.timesheets = timesheetSplit;
            } else {
                this.getConfirmedPayroll();
            }
        },

        // filterPayrollTable() {
        //     this.filterPayrollDialog = false;
        // },

        downloadPayroll() {
            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }
            
            window.open(`${url}/customCompanyPayrolls/downloadPayroll?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.generatePayrollFrom}&DateEnd=${this.generatePayrollTo}&Timezone=${this.userTimezone}&userState=${this.state}&userRole=${this.userRole}`, '_blank')
            
            // window.location.href = `${url}/payroll/downloadPayroll?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.dateStart}&DateEnd=${this.dateEnd}&Timezone=${this.userTimezone}`;
        },

        downloadPaychecks() {
            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }
            
            window.open(`${url}/customCompanyPayrolls/downloadPaychecks?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.generatePayrollFrom}&DateEnd=${this.generatePayrollTo}&Timezone=${this.userTimezone}`, '_blank')
            
            // window.location.href = `${url}/payroll/downloadPaychecks?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.dateStart}&DateEnd=${this.dateEnd}&Timezone=${this.userTimezone}`;
        },

        editItem(item) {
            this.editedIndex = this.timesheets.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.editedItemDialog = true;
        },

        closeItem() {
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.editedItemDialog = false;
                this.isLoadingSaveEditedItemBtn = false;
            }, 300)
        },

         saveItem() {
            this.isLoadingSaveEditedItemBtn = true;

            if (this.editedIndex > -1) {
                try {
                    if (this.isViewGeneratedPayroll) {
                        let req_body = {
                            selectedGeneratedPayroll_id: this.selectedGeneratedPayroll_id,
                            editedItem: this.editedItem
                        }

                        axios.put(`${url}/customCompanyPayrolls/updateSavedPayroll`, req_body).then(res => {
                            if (res.data.success) {
                                this.snackbar = true;
                                this.snackbarText = "Item updated."
                                this.snackbarColor = "success"
                            }
                        }).catch(error => {
                            this.snackbar = true;
                            this.snackbarText = "Error on update."
                            this.snackbarColor = "error"

                            console.log(error.response.data);
                        })
                    }
                } finally {
                    Object.assign(this.timesheets[this.editedIndex], this.editedItem)
                }
            }
            
            this.closeItem()
        },

        async saveGeneratePayrolls() {
            this.isSaveGeneratedPayrollsLoadingBtn = true;
            if (this.timesheets.length > 0) {
                let req_body = {
                    Company: this.userCompanies,
                    PayrollType: "workstream",
                    DateStart: this.generatePayrollFrom,
                    DateEnd: this.generatePayrollTo,
                    DateGenerate: new Date(),
                    Payroll: this.timesheets,
                    State: this.state
                }
                await axios.post(`${url}/customCompanyPayrolls/save/generatedpayrolls`, req_body).then(res => {
                    if (res.data.success) {
                        this.snackbar = true;
                        this.snackbarText = "Saved generated payrolls."
                        this.snackbarColor = "success"
                    }
                }).catch(error => {
                    console.log(error.response.data);
                }).finally(() => {
                    this.getGeneratedPayrolls();

                    this.isSaveGeneratedPayrollsLoadingBtn = false
                })
            } else {
                this.snackbar = true;
                this.snackbarText = "Empty payrolls table."
                this.snackbarColor = "warning"

                this.isSaveGeneratedPayrollsLoadingBtn = false
            }
        },

        async getGeneratedPayrolls() {
            this.generatedPayrolls = [];
            this.generatedPayrollsLoading = true;

            let req_body = {
                Company: this.userCompanies,
                State: this.state
            }
            await axios.get(`${url}/customCompanyPayrolls/getGeneratedPayrolls`, req_body).then(res => {
                if (res.data.success) {
                    res.data.payroll.forEach(item => {
                        item.DateStart = moment(item.DateStart).format("YYYY-MM-DD");
                        item.DateEnd = moment(item.DateEnd).format("YYYY-MM-DD");
                        item.DateGenerate = moment(item.DateGenerate).format("YYYY-MM-DD, h:mm:ss a");

                        this.generatedPayrolls.push(item)
                    })
                }
            }).finally(() => {
                this.generatedPayrollsLoading = false;
            })
        },

        viewGeneratedPayrolls(item) {
            this.generatePayrollIsLoading = true;
            this.isLoadingConfirmedPayroll = true;

            try {
                this.timesheets = [];
                this.timesheets = item.Payroll;
                this.generatePayrollFrom = item.DateStart;
                this.generatePayrollTo = item.DateEnd;
                this.selectedGeneratedPayroll_id = item._id
                
                this.isViewGeneratedPayroll = true;
                this.SplitOvernight = false;
            } finally {
                this.generatePayrollIsLoading = false;
                this.isLoadingConfirmedPayroll = false;
                this.generatedPayrollDialog = false;
            }
        },

        isDisabledCheckboxAndRadioBtn() {
            if (this.generatePayrollFrom == '' && this.generatePayrollTo == '') {
                return true;
            } else if (this.generatePayrollFrom == undefined && this.generatePayrollTo == undefined) {
                return true;
            } else {
                return false;
            }
        },

        async resetData () {
            if (this.rhsPayroll) {
                this.generatePayrollFrom = '';
                this.generatePayrollTo = '';
            }
        }

    },

}
</script>
<style scoped>
>>> .edited-field input {
    width: 50px;
}
</style>
